import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdDirector from "@/pages/admin/AdDirector";

export const Route = createFileRoute("/admin/ad-director")({
  head: () => pageHead("Admin \u2014 Ad Director \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdDirector,
});
